// ClientIdContext.js
import { createContext, useContext } from "react";

export const ClientIdContext = createContext(null);

export const useClientId = () => useContext(ClientIdContext);
